import { render, staticRenderFns } from "./SetUsernameDialog.vue?vue&type=template&id=d5b4d1ba"
import script from "./SetUsernameDialog.vue?vue&type=script&lang=js"
export * from "./SetUsernameDialog.vue?vue&type=script&lang=js"
import style0 from "./SetUsernameDialog.vue?vue&type=style&index=0&id=d5b4d1ba&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports